import { BRAND, CTA } from "../content/brand.js";

/** Privacy-light, dependency-free. No-ops until an analytics snippet is added. */
function track(event: string) {
  const w = window as unknown as { plausible?: (name: string) => void };
  w.plausible?.(event);
}

type Placement = "hero" | "close";

export function CtaGroup({
  placement,
  secondaryHref,
}: {
  placement: Placement;
  /** Hero only: in-page scroll to the thesis. Omitted at the close. */
  secondaryHref?: string;
}) {
  return (
    <div className="cta-row">
      <a
        className="cta cta--primary"
        href={`mailto:${BRAND.contactEmail}`}
        onClick={() => track(`cta_email_${placement}`)}
      >
        {CTA.primaryLabel}:{" "}
        <span className="cta-address">{BRAND.contactEmail}</span>
      </a>
      {secondaryHref ? (
        <a
          className="cta cta--secondary"
          href={secondaryHref}
          onClick={() => track(`cta_thesis_${placement}`)}
        >
          {CTA.secondaryLabel} <span aria-hidden="true">↓</span>
        </a>
      ) : null}
    </div>
  );
}
